import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  background-color: #fff;
  flex: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 10px 0;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 6px;
  right: 15px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }
`;

export const Form = styled.form`
  width: 220px;
  margin: 0 auto;

  svg {
    margin-right: 10px;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 280px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 60px);
    padding-top: 25px;
  `}
`;

export const Field = styled.div`
  position: relative;
`;

export const TextInput = styled.input`
  font-size: 0.95em;
  width: 220px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(231, 231, 231);
  border-image: initial;
  border-radius: 4px;
  padding: 2px 5px;
  margin: 8px 0;

  &:focus {
    box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
      rgba(233, 102, 163, 0.6) 0px 0px 8px;
    border-color: rgb(121, 217, 217);
    outline: none;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 280px;
    padding: 5px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 60px);
    margin: 7px 0;
  `}
`;

export const Info = styled.div`
  position: absolute;
  bottom: -6px;
  font-size: 0.7em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 700;
`;

export const Buttons = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
`;

export const SaveButton = styled.button`
  font-weight: bold;
  color: #fff;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 85px;
  margin: 0 auto;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
  }
`;

export const CancelButton = styled.button`
  font-weight: bold;
  color: #79D9D9;
  padding: 5px 25px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 100px;
  margin: 0 auto;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
    color: #fff;
  }
`;
